import React from 'react';
import { observer } from 'mobx-react';
import { ExerciseUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import Button from 'components/button/button';
import { ChatOutlineIcon } from '@seedlang/icons';
import autobind from 'autobind-decorator';
import { last } from 'lodash';
import { computed } from 'mobx';
import styled from '@emotion/styled';

const TabButton = styled(Button)`
  .chat-outline-icon {
    width: 13px;
    margin: 5px 3px 0 0;
    svg {
      fill: #333;
    }
  }
`;

@observer
class WorksheetTab extends React.Component {

  static defaultProps = {
    activeColor: '#333',
    activeBackground: '#FFF',
  };

  @autobind routeIs(name) {
    if (this.props.routeName.includes('custom_tab')) {
      return name.endsWith(last(ExerciseUI.routeStore.router?.routes)?.name) && this.props.params.customTabId === this.props.customTabId;
    }
    return name.endsWith(last(ExerciseUI.routeStore.router?.routes)?.name);
  }

  @autobind routeTo(name) {
    ExerciseUI.routeStore.routeToNamed(name, {
      worksheetId: this.props.worksheetId,
      exerciseId: ExerciseUI.defaultExerciseId,
      customTabId: this.props.customTabId,
    });
  }

  @computed get isActive() {
    const routeMatches = this.routeIs(this.props.routeName);
    const exercisesOnLearningPath =
      this.props.routeName === 'learn.exercises.show' &&
      ExerciseUI.routeStore.routeName === 'learn.index';
    return routeMatches || exercisesOnLearningPath;
  }

  render() {
    return (
      <TabButton
        role='tab'
        aria-selected={this.isActive}
        aria-controls={`tabpanel-${this.props.buttonText}`}
        height='40px'
        fontSize={this.props.small ? '12px' : '14px'}
        color={this.isActive ? this.props.activeColor : '#333'}
        borderRadius={this.props.small ? '10px' : '10px 10px 0 0'}
        background={this.isActive ? this.props.activeBackground : '#D8D8D8'}
        backgroundOnHover={this.isActive ? null : '#c7c7c7'}
        padding={this.props.small ? '10px' : '20px'}
        onClick={() => this.routeTo(this.props.routeName)}
        width={null}
        minWidth={this.props.minWidth}
        flex={this.props.small ? 1 : null}
      >
        {
          isPresent(this.props.iconName) && this.props.iconName !== 'ChatOutline' &&
          <i className={`fa fa-${this.props.iconName}`}/>
        }
        {
          this.props.iconName === 'ChatOutline' &&
          <ChatOutlineIcon />
        }
        {this.props.buttonText.toUpperCase()}
      </TabButton>
    );
  }
}

export default WorksheetTab;
